var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOutOfRange(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "23px",
    height: "23px",
    viewBox: "0 0 23 23",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M18.5,1.5 L0.5,19.5",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Concept",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Task-Handlers---On-Shift---01",
    transform: "translate(-499.000000, -383.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-28",
    transform: "translate(501.000000, 384.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(10.000000, 10.000000) rotate(-90.000000) translate(-10.000000, -10.000000) translate(0.000000, 2.000000)",
    fill: "#FBB034",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 10,
    cy: 13,
    r: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.999675,5.36815 C8.004825,5.36815 6.13055,6.144575 4.722,7.55475 C4.47565,7.801425 4.475975,8.20085 4.72265,8.4472 C4.969,8.6929 5.3681,8.69355 5.6151,8.44655 C6.7851,7.27525 8.3425,6.630125 9.999675,6.630125 C11.65685,6.630125 13.214575,7.27525 14.385225,8.44655 C14.5084,8.57005 14.669925,8.631475 14.83145,8.631475 C14.992975,8.631475 15.154175,8.57005 15.277675,8.446875 C15.524025,8.200525 15.524025,7.8011 15.277675,7.55475 C13.868475,6.144575 11.9942,5.36815 9.999675,5.36815 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.999675,0.32025 C6.635925,0.32025 3.474975,1.62935 1.098575,4.007375 C0.852225,4.253725 0.852225,4.65315 1.0989,4.8995 C1.222075,5.022675 1.383275,5.0841 1.5448,5.0841 C1.706325,5.0841 1.86785,5.022675 1.991025,4.899175 C4.128875,2.76035 6.97295,1.582225 9.999675,1.582225 C13.026075,1.582225 15.87015,2.76035 18.009625,4.8995 C18.255975,5.14585 18.655725,5.14585 18.902075,4.8995 C19.148425,4.652825 19.148425,4.253725 18.902075,4.00705 C16.524375,1.62935 13.3631,0.32025 9.999675,0.32025 Z",
    id: "Path"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Line-8",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("use", {
    stroke: "#FFFFFF",
    strokeWidth: 4,
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    stroke: "#FBB034",
    strokeWidth: 1,
    xlinkHref: "#path-1"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutOfRange);
export default __webpack_public_path__ + "static/media/out-of-range.e339ee1051cf5c8fcd0263d2dd60178b.svg";
export { ForwardRef as ReactComponent };